<template>
  <canvas
    ref="canvas"
    :width="width"
    :height="height"
    style="border:1px solid #ccc; border-radius:4px; background:#fff;"
  ></canvas>
</template>

<script>
import SignaturePad from 'signature_pad';

export default {
  name: 'SignaturePad',
  props: {
    width: { 
      type: Number, 
      default: 500 
    },
    height: { 
      type: Number, 
      default: 200 
    },
    penColor: { 
      type: String, 
      default: '#000' 
    },
    backgroundColor: { 
      type: String, 
      default: '#fff' 
    },
  },
  data() {
    return {
      signaturePad: null,
    }
  },
  mounted() {
    this.signaturePad = new SignaturePad(this.$refs.canvas, {
      penColor: this.penColor,
      backgroundColor: this.backgroundColor
    });

    this.signaturePad.addEventListener('endStroke', () => {
      this.$emit('stroke-end');
    });
  },
  watch: {
    penColor(newColor) {
      if (this.signaturePad) {
        this.signaturePad.penColor = newColor;
      }
    },
    backgroundColor(newColor) {
      if (this.signaturePad) {
        this.signaturePad.backgroundColor = newColor;
      }
    }
  },
  methods: {
    emitStrokeEnd() {
      this.$emit('stroke-end');
    },
    clear() {
      if (this.signaturePad) {
        this.signaturePad.clear();
      } 
    },
    toData() {
      return this.signaturePad ? this.signaturePad.toData() : [];
    },
    fromData(data) {
      if (this.signaturePad) {
        this.signaturePad.fromData(data);
      }
    },
    fromDataURL(data) {
      if (this.signaturePad) {
        this.signaturePad.fromDataURL(data);
      }
    },
    toDataURL(type = 'image/png') {
      return this.signaturePad ? this.signaturePad.toDataURL(type) : '';
    },
  }
}
</script>
